<template>
  <b-modal
    :model-value="show"
    size="xl"
    scrollable
    @update:model-value="$emit('update:show', $event)"
  >
    <template #modal-header>
      <span>
        <i class="far fa-list-alt text-primary mr-2"></i>
        Nilai
      </span>
    </template>

    <template #default>
      <pdf v-if="url && extention == 'pdf'" :src="url"></pdf>
      <table v-else-if="url && excelData.length" class="mt-4 border-collapse border w-full">
        <thead>
          <tr>
            <th v-for="(col, i) in excelData[0]" :key="'head-' + i" class="border p-2 bg-gray-100">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, r) in excelData.slice(1)" :key="'row-' + r">
            <td v-for="(cell, c) in row" :key="'cell-' + c" class="border p-2">
              {{ cell }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="text-center">Gagal load file</div>
    </template>

    <template #modal-footer>
      <b-button type="button" size="sm" variant="success" @click="download()">
        <i class="fa mr-1" :class="extention === 'pdf' ? 'fa-file-pdf' : 'fa-file-excel'"></i>
        Download
      </b-button>
      <b-button size="sm" variant="info" @click="close()">
        <i class="fas fa-times mr-1"></i>
        Tutup
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import pdf from 'vue-pdf'
import * as XLSX from 'xlsx'

export default {
  components: { pdf },
  props: {
    url: { type: String, default: '' },
    show: { type: Boolean, default: false },
  },
  emits: ['update:show', 'close'], // ✅ deklarasikan emit yang dipakai
  data() {
    return {
      extention: 'pdf',
      excelData: [],
    }
  },
  watch: {
    url() {
      this.extention = this.getExtention(this.url)
      if (['xls', 'xlsx'].includes(this.extention)) {
        this.loadExcel()
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
      this.$emit('close', false)
    },
    async loadExcel() {
      try {
        const response = await fetch(this.url)
        const blob = await response.blob()
        const arrayBuffer = await blob.arrayBuffer()
        const workbook = XLSX.read(arrayBuffer, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
      } catch (err) {
        this.$swal.fire({
          icon: 'warning',
          title: err.message || 'Gagal memuat file',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
    async download() {
      try {
        const res = await this.$axios.get(this.url, { responseType: 'blob' })
        const FILE = window.URL.createObjectURL(new Blob([res.data]))
        const docUrl = document.createElement('a')
        docUrl.href = FILE
        docUrl.setAttribute('download', this.url.split('/').pop())
        document.body.appendChild(docUrl)
        docUrl.click()
      } catch (res) {
        this.$swal.fire({
          icon: 'warning',
          title: res.response?.data?.message || 'Gagal mengunduh file',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
  },
}
</script>
